import React from 'react';
import { Tab, Tabs, Tooltip, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import type { TServiceClientVehicle } from 'src/interfaces/serviceClient';
import { CapitalizeNames } from 'src/utils/capitalize';

const useStyles = makeStyles(() => ({
    tab: {
        width: 200,
        flexShrink: 0,
        overflow: 'hidden',
        height: 56,
        '& .MuiTab-wrapper': {
            display: 'block',
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    },
}));

type VehicleTabsProps = {
    vehicles: TServiceClientVehicle[];
    value: number;
    onChange: (event: React.ChangeEvent<unknown>, newValue: number) => void;
};

export const VehicleTabs = ({
    vehicles,
    value,
    onChange,
}: VehicleTabsProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const getTabLabel = (vehicle: TServiceClientVehicle) => {
        const raw = `${vehicle.make?.name || ''} ${vehicle.model || '—'} ${
            vehicle.year || ''
        }`.trim();
        if (!raw || raw === '—') return String(t('serviceClients.vehicle'));
        return CapitalizeNames(raw);
    };

    return (
        <Tabs
            value={value}
            onChange={onChange}
            indicatorColor="primary"
            textColor="primary"
            data-testid="vehicle-tabs"
            variant="scrollable"
            scrollButtons="off"
        >
            {vehicles.map((vehicle, index) => (
                <Tooltip title={getTabLabel(vehicle)}>
                    <Tab
                        key={vehicle._id}
                        label={getTabLabel(vehicle)}
                        id={`vehicle-tab-${index}`}
                        aria-controls={`vehicle-tabpanel-${index}`}
                        data-testid={`vehicle-tab-${index}`}
                        className={classes.tab}
                    />
                </Tooltip>
            ))}
        </Tabs>
    );
};
